import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { heroData } from "../data/mockData";

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="hero-section">
      <div className="container">
        <div className="hero-content">
          {/* Logo destacado */}
          <div className="mb-8 animate-fade-in">
            <img 
              src={heroData.logo}
              alt="Instituto Mercosul Amazônia"
              className="h-20 w-auto mx-auto mb-6"
            />
          </div>

          {/* Innovation Badge */}
          <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm rounded-full px-4 py-2 mb-6">
            <Sparkles className="w-4 h-4 text-yellow-500" />
            <span className="text-sm font-medium text-gray-700">Hub de Inovação Amazônica</span>
          </div>

          {/* Main Title */}
          <h1 className="heading-1 mb-6 animate-slide-up">
            {heroData.title}
          </h1>

          {/* Subtitle */}
          <p className="body-large mb-4 max-w-2xl mx-auto animate-slide-up-delay">
            {heroData.subtitle}
          </p>

          {/* Description */}
          <p className="body-medium mb-8 max-w-xl mx-auto text-gray-600 animate-slide-up-delay-2">
            {heroData.description}
          </p>

          {/* CTA Button */}
          <div className="animate-slide-up-delay-3">
            <button 
              onClick={() => scrollToSection('about')}
              className="btn-primary inline-flex items-center gap-2 group"
            >
              {heroData.ctaText}
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
          </div>

          {/* Innovation Highlights 
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-16 max-w-4xl mx-auto">
            <div className="text-center animate-fade-in-up-1">
              <div className="heading-3 text-accent-text">50+</div>
              <div className="body-small">Startups Aceleradas</div>
            </div>
            <div className="text-center animate-fade-in-up-2">
              <div className="heading-3 text-accent-text">15</div>
              <div className="body-small">Patentes Registradas</div>
            </div>
            <div className="text-center animate-fade-in-up-3">
              <div className="heading-3 text-accent-text">1.200+</div>
              <div className="body-small">Jovens Capacitados</div>
            </div>
            <div className="text-center animate-fade-in-up-4">
              <div className="heading-3 text-accent-text">100K+</div>
              <div className="body-small">Hectares Monitorados</div>
            </div>
          </div> */}
        </div>
      </div>

      {/* Scroll Indicator 
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <div className="w-6 h-10 border-2 border-gray-400 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-gray-400 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>*/}
    </section>
  );
};

export default HeroSection;